import React, { useEffect, useState } from "react";
import { useFormik } from "formik"; // ✅ Added Formik
import * as Yup from "yup"; // ✅ Added Yup
import Modal from "@mui/material/Modal";
import { Box, MenuItem, Select, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  CONTENT_TYPE,
  INQUIRY_TYPE,
  TYPE_SUBJECT_LISTING,
} from "../constants/enums";

import { showError, showToast, showWarning } from "../constants/toast";
import { useAddTutorReportMutation } from "../service/inquiry";
import useAuth from "../hooks/useAuth";
import { useParams } from "react-router-dom";
import Loader from "../constants/Loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

interface AddFormProps {
  open: boolean;
  handleClose: () => void;
}

export const ReportTutor = ({ open, handleClose }: AddFormProps) => {
  const [reportApi, { isLoading }] = useAddTutorReportMutation();
  const { id } = useParams();
  const [des, setDes] = useState<string>("");

  const submitReport = async () => {
    if(des===''){
        showWarning("Please add description");
        return;
    }
    let body = {
      tutorId: id,
      report: 1,
      reason: des || "",
    };
    try {
      const res = await reportApi(body).unwrap();
      if (res?.statusCode == 200) {
        setDes("");
        showToast("Report submitted successfully");
        handleClose()
      }
    } catch (error: any) {
      showError(error?.data?.message);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Loader isLoad={isLoading} />
        <div className="form_discuss">
          <div
            className="btn-close"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
          >
            <CloseIcon onClick={handleClose} />
          </div>

          <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Description
          </Typography>
          <form className="form" style={{ marginTop: "20px" }}>
            <div className="control_group" style={{ marginTop: "15px" }}>
              <TextField
                fullWidth
                placeholder="Write your reason.."
                name="other"
                value={des}
                onChange={(e) => {
                  if (e.target.value !== " ") {
                    setDes(e.target.value);
                  }
                }}
                minRows={4}
                multiline
                maxRows={6}
              />
            </div>

            <div className="form_btn">
              <button className="btn transparent" onClick={()=>{
                handleClose();
                setDes("");
              }}>
                Cancel
              </button>
              <button onClick={()=>submitReport()} type="button" className=" btn primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </Box>
    </Modal>
  );
};
